import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';

export default class JUAccountButton extends TKCustomElementFactory {
    initialsTextElement: HTMLSpanElement | null;

    constructor() {
        super();
        this.initialsTextElement = this.querySelector('[data-ju-initials]');
    }

    connectedCallback(): void {
        this.setUpInitialsElement();
    }

    setUpInitialsElement() {
        if (!this.initialsTextElement) throw new Error('Initials element missing');
        const fullNameText = this.initialsTextElement.getAttribute('data-ju-full-name') || '';
        if (!fullNameText) throw new Error('Missing full name attribute');
        const initials = fullNameText.split(' ')
            .filter((w) => w.length > 0)
            .map((w) => w[0])
            .join('');
        this.initialsTextElement.innerText = initials;
    }
}
